// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"dbea1611","793":"c60f7a1f"}[chunkId] + ".chunk.css";
};